<div class="wrapper-page faq-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span *ngIf="categoryId !== 'inactive'" class="header-text">Biznis korisnici ({{this.urlParams.business_category ? 'Aktivnih: ' + activeUsers + ',
        Neaktivnih: ' + inactiveUsers : this.businessUsersPagination?.totalItems}})</span>
      <span *ngIf="categoryId === 'inactive'" class="header-text">Biznis korisnici ({{activeUsers}})</span>
    </div>
    <div>
      <gr-search (searchQueryChange)="onSearchChange($event)"></gr-search>
      <gr-dropdown *ngIf="categoryId !== 'inactive'" style="margin: 0px 32px; display: block;"
        [items]="[{name: 'Naziv kompanije', prop: 'name'}, {name: 'Maticni broj', prop: 'identification_number'}, {name: 'PIB', prop: 'tax_identification_number'}]"
        [propIdentifier]="'prop'"
        [dropdownLabel]="''"
        [placeholder]="''"
        [defaultSelected]="{name: 'Naziv kompanije', prop: 'name'}"
        (selectItem)="onColumnSelected($event)">
      </gr-dropdown>
    </div>
    <div class="grid xs-pr-32 xs-pl-32 business-table">
      <div class="grid__m-12">
        <div class="zc-table">
          <div class="zc-header-table">
            <div class="zc-header-row">
              <div class="zc-header-column">
                <span>ID</span>
              </div>
              <div class="zc-header-column">
                <span>Status</span>
                <div class="wrapper-sort" (click)="onSortChange('active')"
                  [ngClass]="{'active': urlParams.sort === 'active'}">
                  <i class="fa-solid"
                    [ngClass]="(urlParams.sort === 'active' && urlParams.direction === 'desc') ? 'fa-arrow-up-a-z': 'fa-arrow-down-a-z'"></i>
                </div>
              </div>
              <div class="zc-header-column">
                <span>Naziv</span>
                <div class="wrapper-sort" (click)="onSortChange('name')"
                  [ngClass]="{'active': urlParams.sort === 'name'}">
                  <i class="fa-solid"
                    [ngClass]="(urlParams.sort === 'name' && urlParams.direction === 'desc') ? 'fa-arrow-up-a-z': 'fa-arrow-down-a-z'"></i>
                </div>
              </div>
              <div class="zc-header-column">
                <span>Opis</span>
                <div class="wrapper-sort" (click)="onSortChange('description')"
                  [ngClass]="{'active': urlParams.sort === 'description'}">
                  <i class="fa-solid"
                    [ngClass]="(urlParams.sort === 'description' && urlParams.direction === 'desc') ? 'fa-arrow-up-a-z': 'fa-arrow-down-a-z'"></i>
                </div>
              </div>
              <div class="zc-header-column">
                <span>Grad</span>
                <div class="wrapper-sort" (click)="onSortChange('business_location_id')"
                  [ngClass]="{'active': urlParams.sort === 'business_location_id'}">
                  <i class="fa-solid"
                    [ngClass]="(urlParams.sort === 'business_location_id' && urlParams.direction === 'desc') ? 'fa-arrow-up-a-z': 'fa-arrow-down-a-z'"></i>
                </div>
              </div>
              <div class="zc-header-column">
                <span>Datum registracije</span>
                <div class="wrapper-sort" (click)="onSortChange('created_at')"
                  [ngClass]="{'active': urlParams.sort === 'created_at'}">
                  <i class="fa-solid"
                    [ngClass]="(urlParams.sort === 'created_at' && urlParams.direction === 'desc') ? 'fa-arrow-up-a-z': 'fa-arrow-down-a-z'"></i>
                </div>
              </div>
              <div class="zc-header-column column-buttons">
                <span>Alatke</span>
              </div>
            </div>
          </div>
          <div class="zc-content-table">
            <div class="zc-content-row" *ngFor="let company of businessUsersList"
              [ngClass]="{'active-user': company?.active}">
              <div class="zc-content-column">
                <span>{{company?.user_id}}</span>
              </div>
              <div class="zc-content-column">
                <span>{{company?.active ? 'Aktivan': 'Neaktivan'}}</span>
              </div>
              <div class="zc-content-column">
                <span>{{company?.name}} <img *ngIf="company?.identification_number === '63437433'" style="margin-left: 8px;" src="../../../../assets/icons/landing/star-rating.svg" alt=""></span>
              </div>
              <div class="zc-content-column">
                <span [innerHTML]="company?.description ? (company.description | extractFirstParagraph) : ''"></span>
              </div>
              <div class="zc-content-column">
                <span>{{company?.business_location?.name}}</span>
              </div>
              <div class="zc-content-column">
                <span>{{company?.created_at | date:'dd.MM.yyyy'}}</span>
              </div>
              <div class="zc-content-column column-buttons">
                <div class="buttons-group">
                  <div class="wrapper-button">
                    <i class="fa-solid fa-eye" [routerLink]="[PAGES_AND_PATHS.businessProfile.pagePath, company?.id]"
                      [state]="{isNewBusiness: this.urlParams.business_category, categoryId: categoryId}"></i>
                  </div>
                  <div class="wrapper-button" (click)="businessUserForEdit = company?.user ? company.user : null">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </div>
                  <div class="wrapper-button" (click)="businessUserForDelete = company">
                    <i class="fa-solid fa-trash"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="grid__m-12">
        <gr-pagination *ngIf="businessUsersList.length" [currentPage]="businessUsersPagination?.currentPage"
          [pagId]="'js-business-users-table-pagination'" [perPage]="businessUsersPagination?.perPage"
          [totalItems]="businessUsersPagination?.totalItems" (pageChanged)="onPageChanged($event)">
        </gr-pagination>
      </div>
    </div>
  </div>
</div>

<gr-edit-business-user-modal *ngIf="businessUserForEdit" [businessUserForEdit]="businessUserForEdit"
  (closeModal)="businessUserForEdit = null" (confirmModal)="onConfirmEditBusinessUser()"></gr-edit-business-user-modal>

<gr-confirm-modal *ngIf="businessUserForDelete" [modalTitle]="'Brisanje biznis korisnika'"
  [modalDescription]="'Da li ste sigurni da želite da obrišete biznis korisnika?'"
  (closeModal)="businessUserForDelete = null"
  (confirmModal)="removeBusinessUser(businessUserForDelete ? businessUserForDelete.user_id : null)">
</gr-confirm-modal>
